/*
 * DataTableEmpty
 * @module DataTable
 * @flow
 */

import React from 'react';
import styled, { css } from 'styled-components/macro';
import { ifProp } from 'styled-tools';
// $FlowIssue
import { FormattedMessage } from 'react-intl';

import { Gag } from '~/components/Gag';
import { Button } from '~/components/Button';
// $FlowIssue
import { ReactComponent as IconSearchResult } from '@/icons/ic-search-result.svg';

import messages from './messages';

export type DataTableEmptyProps = {
  onReset?: () => void,
  loading?: boolean,
};

const DataTableEmptyGap = styled(Gag)`
  min-height: 280px;
  ${ifProp(
    'highlighted',
    css`
      top: 37px;
    `,
    css`
      left: -24px;
      width: calc(100% + 24px);
    `,
  )};
`;

/**
 * DataTableEmpty React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {Function} [props.onReset] - on filter reset handler
 * @param {string} [props.palette = 'primary'] - current button palette
 * @example <caption>Simple usage</caption>
 * <DataTableEmpty >
 * @returns {React.Node<*>} React-component
 */
export const DataTableEmpty = ({
  loading,
  onReset,
  ...rest
}: DataTableEmptyProps) =>
  loading ? null : (
    <DataTableEmptyGap
      testid="datatable-empty"
      icon={<IconSearchResult />}
      title={<FormattedMessage {...messages.title} />}
      description={
        <FormattedMessage {...messages[onReset ? 'filter' : 'result']} />
      }
      {...rest}
    >
      {onReset && (
        <Button small onClick={onReset}>
          <FormattedMessage {...messages.resetButton} />
        </Button>
      )}
    </DataTableEmptyGap>
  );
